import styled from 'styled-components'

const Text = styled.h5``

export default Text
